import React from "react";
import "font-awesome/css/font-awesome.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons/faCrosshairs";
import { faCircleCheck, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLocation } from "@fortawesome/free-solid-svg-icons/faLocation";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

export const Footer = () => {
  return (
    <footer className="main-footer footer-style-one">
      <div className="widgets-section" style={{ width: "80%", margin: "auto" }}>
        <div className="auto-container">
          <div className="row">
            <div className="footer-column col-xl-3 col-sm-6">
              <div className="footer-widget about-widget">
                <div className="text">
                  Welcome to the best five-star deluxe hotel in New York. Hotel
                  elementum sesue the aucan volutpat.
                </div>
                <ul className="social-icon-two">
                  <li>
                    <a href="/page-contact#">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="/page-contact#">
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="/page-contact#">
                      <i className="fab fa-pinterest"></i>
                    </a>
                  </li>
                  <li>
                    <a href="/page-contact#">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-column col-lg-2 col-sm-6 mb-0">
              <div
                className="footer-widget links-widget wow fadeInLeft"
                data-wow-delay="200ms"
              >
                <h4 className="widget-title">Services Links</h4>
                <div className="widget-content">
                  <ul className="user-links">
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> Home
                      </a>
                    </li>
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> Rooms &amp;
                        Suites
                      </a>
                    </li>
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> Restaurant
                      </a>
                    </li>
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> Spa &amp;
                        Wellness
                      </a>
                    </li>
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> About Hotel
                      </a>
                    </li>
                    <li>
                      <a href="/page-contact#">
                        <FontAwesomeIcon icon={faCrosshairs} /> Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-column col-lg-3 col-sm-6">
              <div
                className="footer-widget info-widget wow fadeInLeft"
                data-wow-delay="300ms"
              >
                <h4 className="widget-title">Information</h4>
                <div className="widget-content">
                  <article className="recent-post">
                    <div className="inner">
                      <div className="post-info">
                        <FontAwesomeIcon icon={faPhone} />
                        1800-121-3637
                      </div>
                      <div className="post-info">+91-7052-101-786</div>
                      <div className="post-info">
                        <FontAwesomeIcon icon={faEnvelope} /> info@example.com
                      </div>
                      <div className="post-info">
                        <FontAwesomeIcon icon={faLocation} /> 1247/Plot No. 39,
                        15th Phase, <br />
                        United States of America
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
            <div className="footer-column col-lg-3 col-sm-6">
              <div
                className="footer-widget news-widget wow fadeInLeft"
                data-wow-delay="400ms"
              >
                <h4 className="widget-title">Newsletter</h4>
                <div className="text">
                  Lorem ipsum dolor sit amet consectetur Augue id fermentum
                </div>
                <div className="subscribe-form-three">
                  <form method="post" action="#">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="email"
                        placeholder="Email Address"
                      />
                      <button type="button" className="theme-btn btn-style-one">
                        <span className="btn-title">
                          <FontAwesomeIcon icon={faPaperPlane} />
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
                <div className="text">
                  <FontAwesomeIcon icon={faCircleCheck} />I agree to all terms
                  and policies
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="auto-container">
          <div className="inner-container">
            <a className="scroll-to-top scroll-to-target d-block" href="#top">
              <span className="fa fa-angle-up"></span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
